export default __webpack_public_path__ + "static/media/Boston.bcdeb949.jpg";